import ExternalDonationsAPI from './api'
import { objectToCamelCase } from '../utils'

export default class ExternalDonation {
  static api = ExternalDonationsAPI.create(ExternalDonation)
  static readOnlyFields = ['id']
  constructor(externalDonation) {
    const {
      type = '',
      amount = '',
      dateDonated = '',
      email = '',
      firstName = '',
      lastName = '',
      zipCode = '',
      frequency = '',
      employeeCode = '',
      organization = '',
      subOrganization = '',
      dateAdded = '',
    } = externalDonation

    Object.assign(this, {
      type,
      amount,
      dateDonated,
      email,
      firstName,
      lastName,
      zipCode,
      frequency,
      employeeCode,
      organization,
      subOrganization,
      dateAdded,
    })
  }

  static create(opts) {
    return new ExternalDonation(opts)
  }
  static fromAPI(json) {
    return new ExternalDonation(objectToCamelCase(json))
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof ExternalDonation)) {
      throw Error(`${name} must be an instance of the EmployeeCode class.`)
    }
  }
}
